import { render, staticRenderFns } from "./Circle.vue?vue&type=template&id=5c36cd16&scoped=true"
import script from "./Circle.vue?vue&type=script&lang=js"
export * from "./Circle.vue?vue&type=script&lang=js"
import style0 from "./Circle.vue?vue&type=style&index=0&id=5c36cd16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c36cd16",
  null
  
)

export default component.exports